import React from 'react';
import './Footer.scss';
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/solid.css'
import '@fortawesome/fontawesome-free/css/brands.css'

export default () => {
  return (
    <footer>
      <a href="https://www.linkedin.com/in/elayudhanira/" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
      <a href="https://github.com/helloimela/" target="_blank"><i class="fa-brands fa-github"></i></a>
    </footer>
  );
};
